// Mirrors the server limits in CrewmatesBackend/src/security/uploadPolicy.js. Keep the two
// in step. The server answers any breach with a generic "Upload limits exceeded." that does
// not say which limit tripped, so a client that quietly exceeds one is very hard to
// diagnose from the outside - these constants exist so the client can fail clearly first.
export const MAX_UPLOAD_FILE_BYTES = 25 * 1024 * 1024;
export const MAX_UPLOAD_FILES_PER_REQUEST = 10;

// The server's hard request cap is 50 MB, measured off Content-Length before parsing.
// Batch below it so multipart boundaries, field names and the per-file "orders" values
// cannot push a batch that looked safe over the edge.
export const MAX_UPLOAD_REQUEST_BYTES = 40 * 1024 * 1024;

export function formatBytes(bytes) {
  const mb = Number(bytes) / (1024 * 1024);
  if (!Number.isFinite(mb)) return 'unknown size';
  return `${mb >= 10 ? Math.round(mb) : mb.toFixed(1)} MB`;
}
